import '@/theme/core/index.less'
//AntDesign UI组件库
import Antd, { ConfigProvider } from 'ant-design-vue'
import 'ant-design-vue/es/message/style/css'
import 'ant-design-vue/es/modal/style/css'

import { createApp } from 'vue'
import App from '@/App.vue'
import { initApiConfig, loadExternalScript, setDownloadVerifyApiHost, handleUrlJump } from '@/context/system'
import dragModal from '@/plugins/drag'
import inputSelect from '@/plugins/input-select'
import VueDOMPurifyHTML from 'vue-dompurify-html'
// 路由
import { router } from '@/router'
import { isDev } from './config/dev'
import { getApiUrl } from './config/http.config'

import { createPinia } from 'pinia'

initApiConfig()
// handleUrlJump()

// 文件下载验证码校验
loadExternalScript(getApiUrl('appcenterWebsite') + 'downloadVerify.js?v=' + new Date().getTime())
setDownloadVerifyApiHost(getApiUrl('platformApi2'))

const app = createApp(App)
if (isDev()) {
  app.use(Antd)
  import('ant-design-vue/dist/antd.less')
  // import('ag-grid-community/dist/styles/ag-theme-balham-dark.css')
  // import('ag-grid-community/dist/styles/ag-theme-alpine.css')
}

const pinia = createPinia()

// 国际化配置
app.use(ConfigProvider)
app.use(router)
app.use(dragModal)
app.use(inputSelect)
app.use(pinia)
app.use(VueDOMPurifyHTML)
app.mount('#app')
